import { render, staticRenderFns } from "./DiscountList.vue?vue&type=template&id=5285f021&scoped=true"
import script from "./DiscountList.vue?vue&type=script&lang=js"
export * from "./DiscountList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5285f021",
  null
  
)

export default component.exports